export default  {
    methods: {
        getNestedProperty: function(obj, ...args) {
            return args.reduce((obj, level) => obj && obj[level], obj)
        }
    }
}